import { NodeStruct } from '@/types/node-types';

/**
 * Field id of the shared interactive-feedback toggle (backend:
 * ``workflow.node.base.interactive_feedback``). Present on the chat-output
 * nodes ("Enable interactive feedback chat") AND the agent /
 * code-interpreter nodes ("Ask for feedback on outputs").
 */
export const INTERACTIVE_FEEDBACK_FIELD_ID = 'enable_interactive_feedback';

/**
 * Whether a node can host the live node chat.
 *
 * Baseline rule (unchanged): only skip chat when ``has_chat`` is
 * explicitly false — older/catalog payloads omit the flag on chat-capable
 * nodes and should still connect.
 *
 * Extension: agent-family nodes report ``has_chat: false`` in the catalog,
 * but with "Ask for feedback on outputs" toggled ON they pause via the
 * same chat protocol as the chat-output nodes — so a node whose
 * ``enable_interactive_feedback`` param is enabled counts as
 * chat-capable regardless of ``has_chat``.
 */
export const nodeSupportsChat = (struct?: NodeStruct | null): boolean => {
  if (!struct) return true;
  if (struct.has_chat !== false) return true;
  const feedbackParam = struct.params?.find(
    (param) => param.field_id === INTERACTIVE_FEEDBACK_FIELD_ID,
  );
  // Match the toggle renderers (node-input-renderer / node-advanced-modal),
  // which treat both ``true`` and ``1`` as ON.
  return feedbackParam?.value === true || feedbackParam?.value === 1;
};
